@if (timesheet) {
  <section id="mobile-timesheet-table-container">
    <mat-card>
      <mat-card-title>
        <div id="task-header">
          <div>{{'tasks.name_full' | translate}}</div>
          @if (timesheet.enableAddMoreTask && !forceSubmissionWithWarnings && ((mode === timesheetMode.ADMIN)
            ||(mode === timesheetMode.USER && timesheet.status === timesheetStatus.EDITABLE))) {
            <button mat-mini-fab
              color="primary"
              (click)="openProjectsModal()">
              <mat-icon style="vertical-align: 0;">control_point</mat-icon>
            </button>
          }
        </div>
      </mat-card-title>
      <mat-card-content>
        <mat-chip-listbox aria-label="Task selection">
          @for (line of selectedLines; track line) {
            <div [class]="'task-box'">
              <mat-chip-option
                color="primary"
                [matMenuTriggerFor]="menu"
                [highlighted]="line.comment?.length > 0"
                [selectable]="false"
                [class]="'task-option'"
                >
                {{ line.task.name }}
              </mat-chip-option>
              <mat-menu #menu="matMenu">
                @if (openCommentBoxAllowed(line)) {
                  <button mat-menu-item
                    (click)="openCommentBoxAllowed(line) && openCommentModal(line)">
                    @if ((line.comment && line.comment.length > 0)) {
                      <mat-icon color="primary">speaker_notes</mat-icon>
                    } @else {
                      <mat-icon>speaker_notes_off</mat-icon>
                    }
                    <span>{{'timesheet.line.actions.comment_line' | translate}}</span>
                  </button>
                }
                @if (line.task.code && line.task.code.length > 0 && line.task.code !== '-') {
                  <button mat-menu-item [disabled]="true">
                    <mat-icon color="primary">qr_code_2</mat-icon>
                    <span>{{'tasks.code' | translate}}: {{line.task.code}}</span>
                  </button>
                }
                @if (openClientModalAllowed(line)) {
                  <button mat-menu-item
                    (click)="openClientModalAllowed(line) && openClientModal(line)">
                    <mat-icon color="primary">work_outline</mat-icon>
                    @if ((line.client && line.client.name)) {
                      <span>{{'tasks.projects.client' | translate}}: {{line.client.name}}</span>
                    } @else {
                      <span>{{'tasks.clients.choose_client' | translate}}</span>
                    }
                  </button>
                }
                @if (!openClientModalAllowed(line) && line.client && line.client.name) {
                  <button mat-menu-item
                    style="cursor: not-allowed" [disabled]="true">
                    <mat-icon color="primary">work_outline</mat-icon>
                    <span>{{'tasks.projects.client' | translate}}: {{line.client.name}}</span>
                  </button>
                }
                @if (isLineDuplicable(line)) {
                  <button mat-menu-item (click)="isLineDuplicable(line) && duplicateLine(line)"
                    >
                    <mat-icon color="primary">content_copy</mat-icon>
                    <span>{{'timesheet.line.actions.duplicate_line' | translate}}</span>
                  </button>
                }
                @if (isLineRemovable(line)) {
                  <button mat-menu-item (click)="isLineRemovable(line) && removeLine(line)"
                    >
                    <mat-icon color="warn">delete_forever</mat-icon>
                    <span>{{'timesheet.line.actions.delete_line' | translate}}</span>
                  </button>
                }
              </mat-menu>
            </div>
          }
        </mat-chip-listbox>
      </mat-card-content>
    </mat-card>
    @if (totalDurationPerDay && totalDurationPerDay.size !== 0) {
      <mat-accordion id="week-accordion">
        @for (day of days; track day) {
          <mat-expansion-panel [expanded]="step === day.number"
            (opened)="setStep(day.number)" hideToggle
            [ngClass]="{
            'mobile-encoding-restriction': !day.encodingAllowed,
            'mobile-personal-holiday': day.personalHolidays,
            'mobile-legal-holiday': day.legalHoliday
            }">
          <mat-expansion-panel-header>
              <mat-panel-title>
                <div>
                  <span class="day-name">{{ day.date | date: 'EEEE':'':translateService.currentLang}}</span>
                  {{day.date | date: 'dd/MM'}}
                </div>
              </mat-panel-title>
              <mat-panel-description>
                <mat-progress-bar id="mobile-progress-indicator"
                  color="accent"
                  mode="determinate"
                  matTooltip="{{'timesheet.encoding.completion' | translate:{n: totalDurationPerDay.get(day.number)} }}"
                  [value]="100 / loggedAccount.organisation.configuration.workingHoursPerDay.value * totalDurationPerDay.get(day.number)">
                </mat-progress-bar>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div id="holiday-container">
              @if (!day.personalHolidays && day.personalHolidays?.length > 0 && !day.legalHoliday) {
                <button mat-mini-fab
                  color="accent"
                  (click)="openHolidayModal(day, action.ADD)">
                  <mat-icon style="vertical-align: 0;">event_busy</mat-icon>
                </button>
              } @else {
                <spurado-chip-list [direction]="'vertical'"
                  aria-label="Holiday type">
                  <!-- Personal -->
                  @if (day.personalHolidays && day.personalHolidays.length > 0 && day.personalHolidays[0].uuid) {
                    <spurado-chip
                      [selected]="true"
                      color="accent"
                      (click)="timesheet.status === timesheetStatus.EDITABLE && isWorkableDay(day) && openHolidayModal(day, action.EDIT)"
                      [removable]="timesheet.status === timesheetStatus.EDITABLE"
                      (remove)="timesheet.status === timesheetStatus.EDITABLE && removeAllHolidays(day.personalHolidays)"
                      [progress]="isFullDayHoliday(day.personalHolidays) ? '100' : day.personalHolidays[0].duration === 'AM' ? '50-start' : '50-end'">
                      <div chipText id="personal-holiday-chip">
                        {{'timesheet.day.holiday.personal' | translate}}
                      </div>
                    </spurado-chip>
                  }
                  <!-- Legal -->
                  @if (day.legalHoliday) {
                    <spurado-chip
                      [ripples]="false"
                      [selected]="true"
                      color="accent">
                      <div chipText>{{'timesheet.day.holiday.legal' | translate}}</div>
                    </spurado-chip>
                  }
                </spurado-chip-list>
              }
            </div>
            @for (data of dataPerDay.get(day.number); track data) {
              <div style="display: flex; flex-direction: column;">
                @if (!loggedAccount.organisation.configuration.dailyPointing.value) {
                  <mat-form-field appearance="fill">
                    <mat-label>{{data.task.name}}@if (data.line.client) {
                      <span>&nbsp;({{data.line.client.name}})</span>
                    }</mat-label>
                    <input type="number" min="0" matInput value="{{data.day.actualDuration}}"
                      (focusout)="saveActual(data.line, data.day, $event)"
                      [disabled]="isActualCellDisabled(timesheet, day.number)">
                    </mat-form-field>
                  } @else {
                    <div style="display: flex; flex-direction: row; padding: 5px;">
                      <mat-label>{{data.task.name}}@if (data.line.client) {
                        <span>&nbsp;({{data.line.client.name}})</span>
                      } :</mat-label>
                      <spurado-timesheet-daily-pointing-btn
                        iconStyleClass="daily-pointing-icon-mobile"
                        [configuration]="loggedAccount.organisation.configuration"
                        [actualDuration]="data.day.actualDuration"
                        (saveActual)="saveActualFromDailyPointing(data.line, data.day, $event)"
                        [disabled]="isActualCellDisabled(timesheet, day.number)">
                      </spurado-timesheet-daily-pointing-btn>
                    </div>
                  }
                </div>
              }
              <mat-action-row>
                <button [disabled]="!(day.number > 1)" mat-button color="warn"
                (click)="prevStep()">{{'common.previous' | translate}}</button>
                <button [disabled]="!(day.number < days.length)" mat-button color="primary"
                (click)="nextStep()">{{'common.next' | translate}}</button>
              </mat-action-row>
            </mat-expansion-panel>
          }
        </mat-accordion>
      }
      @if (totalDurationPerDay && totalDurationPerDay.size !== 0) {
        <div class="mobile-week-selector-container">
          <button mat-icon-button
            color="primary"
            [disableRipple]="true"
            (click)="toggleWeekend()">
            @if (weekEndVisible) {
              <mat-icon>keyboard_arrow_up</mat-icon>
            }
            @if (!weekEndVisible) {
              <mat-icon>keyboard_arrow_down</mat-icon>
            }
          </button>
        </div>
      }
      @if (timesheet!==undefined && timesheet.status === timesheetStatus.EDITABLE && mode === timesheetMode.USER) {
        <div class="action-buttons">
          @if (!timesheet.timesheetLines || timesheet.timesheetLines.length === 0) {
            <h1 class="mat-h1">
              {{'timesheet.no_data' | translate}}<br/>
              <button mat-mini-fab color="primary" (click)="addAllFavoriteTasksToTimesheet()">
                <mat-icon style="vertical-align: 0;" matTooltip="{{'tasks.favorites.tooltip' | translate}}">
                  star
                </mat-icon>
              </button>
            </h1>
          }
          <button mat-raised-button color="primary" [disabled]="isSubmitButtonDisabled()"
            (click)="openSubmissionConfirmationModal(true)">
            <mat-icon style="margin-right: 10px;">send</mat-icon>
            @if (!forceSubmissionWithWarnings) {
              <span>{{'timesheet.actions.submit' | translate}}</span>
            }
            @if (forceSubmissionWithWarnings) {
              <span>{{'timesheet.actions.submit_with_errors' | translate}}</span>
            }
          </button>
        </div>
      }
    </section>
  }
